export default [
    {
        path: '/admin/reports/driver-performances',
        name: 'driver-performance',
        meta: { requiresAuth: true },
        component: () =>
            import('@/pages/report/delivery/driver-performance.vue')
    }
]
